import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { themeMode, fontSize, variant, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var directionStyles = variant({
  prop: "direction",
  variants: {
    horizontal: {
      width: "100%",
      "&:before, &:after": {
        height: "1px"
      }
    },
    vertical: {
      height: "100%",
      flexDirection: "column",
      flexGrow: 1,
      "&:before, &:after": {
        width: "1px"
      }
    }
  }
});
var railStyles = css(["content:' ';flex-grow:1;background-color:", ";"], themeMode({
  light: palette("neutral.200"),
  dark: palette("neutral.700")
}));
var StyledDivider = styled(Box).withConfig({
  componentId: "dllozd-0"
})(["display:flex;align-items:center;justify-content:center;color:", ";font-size:", ";line-height:18px;", " ", ";"], themeMode({
  light: palette("neutral.500"),
  dark: palette("neutral.400")
}), fontSize("sm"), function (_ref) {
  var align = _ref.align;

  switch (align) {
    case "center":
      return css(["&:after,&:before{", "}"], railStyles);

    case "start":
      return css(["&:after{", "}"], railStyles);

    case "end":
      return css(["&:before{", "}"], railStyles);

    default:
      return css([""]);
  }
}, directionStyles);
var StyledDividerContent = styled(Box).withConfig({
  componentId: "dllozd-1"
})(variant({
  prop: "align",
  compoundProp: "direction",
  variants: {
    start: {
      horizontal: {
        pr: "md"
      },
      vertical: {
        pb: "md"
      }
    },
    center: {
      horizontal: {
        px: "md"
      },
      vertical: {
        py: "md"
      }
    },
    end: {
      horizontal: {
        pl: "md"
      },
      vertical: {
        pt: "md"
      }
    }
  }
}));

var Divider = function Divider(_a) {
  var _b = _a,
      children = _b.children,
      _b$direction = _b.direction,
      direction = _b$direction === void 0 ? "horizontal" : _b$direction,
      _b$align = _b.align,
      align = _b$align === void 0 ? "center" : _b$align,
      props = __objRest(_b, ["children", "direction", "align"]);

  return (
    /* @__PURE__ */
    React.createElement(StyledDivider, __spreadValues({
      direction: direction,
      align: align,
      role: "separator"
    }, props), children &&
    /* @__PURE__ */
    React.createElement(StyledDividerContent, {
      align: align,
      direction: direction
    }, children))
  );
};

Divider.displayName = "Divider";
export { Divider };